import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-link-off-icon',
  templateUrl: 'link-off-icon.component.html'
})
export class LinkOffIconComponent {
  constructor() {}
}
